<template>
  <VSkeletonLoader
    class="EventChartSet"
    :loading="events === null || byCategory === null"
    type="image"
  >
    <template #default>
      <div class="charts">
        <VBtn
          v-if="events && events.length && ui.forceXAxisMin !== null"
          class="zoom-out-button"
          :class="{ 'move-left': $vuetify.breakpoint.mdAndUp }"
          @click="ui.forceXAxisMin = ui.forceXAxisMax = null"
        >
          Отменить увеличение
        </VBtn>
        <template v-if="ui.byCategory">
          <div
            v-for="category in categories"
            :key="category.code"
          >
            <EventChart
              v-if="byCategory && (byCategory[category.code] || []).length"
              :key="`category-chart-${category.code}-${ui.redrawKey}`"
              :title="category.name"
              :input-events="byCategory[category.code] || []"
              :grouping="ui.wideView"
              :types-as-categories="ui.typesAsCategories"
              :force-x-axis-min.sync="ui.forceXAxisMin"
              :force-x-axis-max.sync="ui.forceXAxisMax"
              hide-zoom-out
              v-on="$listeners"
            />
          </div>
        </template>
        <template v-else>
          <div
            v-for="user in users"
            :key="user.id"
          >
            <EventChart
              v-if="byUser && (byUser[user.id] || []).length"
              :key="`user-chart-${user.id}-${ui.redrawKey}`"
              :title="$store.getters['user/displayName'](user.id)"
              :input-events="byUser[user.id] || []"
              :grouping="false"
              :types-as-categories="true"
              :force-x-axis-min.sync="ui.forceXAxisMin"
              :force-x-axis-max.sync="ui.forceXAxisMax"
              hide-zoom-out
              v-on="$listeners"
            />
          </div>
        </template>
        <EventChart
          v-if="events && events.length === 0"
          :grouping="false"
          :types-as-categories="false"
          :input-events="[]"
          v-on="$listeners"
        />
      </div>
    </template>
  </VSkeletonLoader>
</template>
<script>
import * as R from 'ramda'
import EventChart from './EventChart'

export default {
  components: { EventChart },
  props: {
    grouping: {
      type: String,
      default: 'user',
      validator: R.includes(R.__, ['user', 'category']),
    },
    wideView: { type: Boolean, default: false },
    typesAsCategories: { type: Boolean, default: false },
  },
  data() {
    return {
      ui: {
        wideView: false,
        byCategory: false,
        typesAsCategories: false,
        forceXAxisMin: null,
        forceXAxisMax: null,
        redrawKey: 0,
      },
    }
  },
  computed: {
    authorized() { return !!this.$store.state.auth.token },
    categories() { return this.$store.getters['category/sorted'] }, // Категории событий
    users() { return this.$store.getters['user/relevant'] }, // Пользователи
    events() { return this.$store.getters['event/events'] }, // События для чарта
    byCategory() {
      const { events } = this
      return events && R.groupBy(R.path(['type', 'categoryCode']), events)
    },
    byUser() {
      const { events } = this
      return events && R.groupBy(R.prop('userId'), events)
    },
  },
  watch: {
    authorized: {
      handler(authorized) {
        // console.warn(`authorized outer watcher: ${authorized}`)
        if (authorized) {
          this.$store.dispatch('user/getList')
          this.$store.dispatch('category/get')
        }
      },
      immediate: true,
    },
    events() {
      this.ui.forceXAxisMin = null
      this.ui.forceXAxisMax = null
      this.ui.redrawKey++
    },
    grouping: {
      handler(grouping) {
        this.ui.byCategory = grouping === 'category'
      },
      immediate: true,
    },
    'ui.byCategory'(groupByCategory, prev) {
      if (groupByCategory === prev) return
      this.$emit('update:grouping', groupByCategory ? 'category' : 'user')
    },
    wideView: {
      handler(wideView) { this.ui.wideView = wideView },
      immediate: true,
    },
    'ui.wideView'(wideView, prev) {
      if (wideView === prev) return
      this.$emit('update:wideView', wideView)
    },
    typesAsCategories: {
      handler(typesAsCategories) {
        this.ui.typesAsCategories = typesAsCategories
      },
      immediate: true,
    },
    'ui.typesAsCategories'(typesAsCategories, prev) {
      if (typesAsCategories === prev) return
      this.$emit('update:typesAsCategories', typesAsCategories)
    },
  },
}
</script>

<style lang="sass" scoped>
  .charts
    .zoom-out-button
      position: fixed
      top: 10px
      right: 15px
      z-index: 7

      &.move-left
        top: 14px
        right: 250px
</style>
